
/**
 * ListManager Class
 *
 * This class manages the list of key pairs. Allowing for relational list to be constructed. 
 *      This way a base key can have 1 or multiple values applied to it
 *
 * @class ListManager
 * @constructor
 * @requires moolite 1.0.1+ 
 *
 */

    var OCS = OCS || {};
    OCS.Classes = OCS.Classes || {};
    OCS.Classes.ListManager = new Class({
        Implements: Options,
        options: {
            debug: false,
            store_arrays: true
        },
        active_storage: {},
        inactive_keys: [],
        /**
         * Set the options and activate the list manager to be ready for use.
         * @method initialize 
         * @param {Object[]} op A list of options to use in inistantiating the class.
         * @param {Boolean} op[].debug Whether the class is being debugged or not.
         * @param {Boolean} op[].store_arrays Option to determine if we are flattening incoming arrays of data or storing as is. Default: true - Store the incoming value as is.
         */
        initialize: function (op) {
            this.setOptions(op);
        },
        /**
         * 
         * @method register
         * @param {String} list_key What the value_id is to be registered to.
         * @param {String|Number} value_id Value to be associated with the list_key
         */
        register: function (list_key, value_id) {
            // If the list_key is in storage add the new value_id to the existing array and clear the inactive keys list
            if (list_key in this.active_storage) {
                if (!(value_id in this.active_storage[list_key])) {
                    this.add_to_active_storage(list_key, value_id);
                }
            } else {
                this.active_storage[list_key] = [];
                this.add_to_active_storage(list_key, value_id);
            }
            /* istanbul ignore if */
            if (this.options.debug) {
                console.debug('list_manager: Register active_storage', this.active_storage);
            }

            // Clear the list of inactive keys
            this.inactive_keys = [];

        },
        /**
         * A method to unregister a value from a key. If list key is defined, we remove it from a specific list, if not, we remove it from all list
         * @method unregister
         * @param {String|Number} in_value_id
         * @param {String} [list_key]
         */
        unregister: function (in_value_id, list_key) {
            if (typeof list_key !== "undefined" && list_key !== null) {
                this.unregister_logic(this.active_storage[list_key], in_value_id);
                // Check if the list key is in further use, if not add it to the inactive_key list.
                if (!this.is_list_key_in_use(list_key)) {
                    this.make_list_key_inactive(list_key);

                }
            } else {
                Object.each(this.active_storage, function (list_ids, list_key) {
                    this.unregister_logic(list_ids, in_value_id);
                    // Check if the list key is in further use, if not add it to the inactive_key list.
                    if (!this.is_list_key_in_use(list_key)) {
                        this.make_list_key_inactive(list_key);
                    }
                }.bind(this));
            }
            /* istanbul ignore if */
            if (this.options.debug) {
                console.debug('list_manager: Unregister active_storage', this.active_storage);
                console.debug('list_manager: Unregister inactive_keys', this.inactive_keys);
            }
        },
        /**
         * A method to test whether or not a list key is in use.
         * @method is_list_key_in_use
         * @param {String} list_key
         * @returns {Boolean}
         */
        is_list_key_in_use: function (list_key) {
            if (this.active_storage.hasOwnProperty(list_key) && this.active_storage[list_key].length > 0) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * If a list key is in use, return back the values associated with that key, if not returns a blank object.
         * @method get_list_key_elements
         * @param {type} list_key
         * @returns {list_manager.active_storage|{}}
         */
        get_list_key_elements: function (list_key) {
            if (list_key && list_key in this.active_storage) {
                return this.clone_object(this.active_storage[list_key]);
            } else {
                // We defined a list key, but nothing was associated with it
                return {};
            }
        },
        /**
         * Get all the active keys that are in active storage.
         * @method get_active_keys
         * @returns {Array}
         */
        get_active_keys: function () {
            return Object.keys(this.active_storage);
        },
        /**
         * 
         * @method add_to_active_storage
         * @param {String} key
         * @param {String|Number} value
         */
        add_to_active_storage: function (key, value) {
            if (!this.options.store_arrays) {
                // We are not storing the array / object as is, but instead flattening it
                if (value && typeof value != 'string' && typeof value != 'number' && (value.length || Object.keys(value).length)) {
                    var is_array = false;
                    var length, array_keys;
                    // Determine if we are working with an array or an object
                    if (value.length) {
                        // We are working with an array
                        is_array = true;
                        length = value.length;
                    } else {
                        // We are working with an object.
                        length = Object.keys(value).length;
                        array_keys = Object.keys(value);
                    }
                    for (var i = 0; i < length; i++) {
                        // Add to the storage based on if its an array or object
                        if (is_array) {
                            this.add_to_active_storage(key, value[i]);
                        } else {
                            this.add_to_active_storage(key, value[array_keys[i]]);
                        }
                    }
                    // Incoming value fully processed, return
                    return;
                }
            }
            if (!(value in this.active_storage[key]) && value !== null) {
                this.active_storage[key].push(value);
            }
        },
        unregister_logic: function (list_ids, in_value_id) {
            var temp_arr = this.clone_object(list_ids);
            Object.each(temp_arr, function (list_value_id, key) {
                if (in_value_id == list_value_id) {
                    list_ids.splice(key, 1);
                }
            });
        },
        clone_object: function (in_obj, prop_keys) {
            // in_obj: The object to be cloned
            // prop_keys: the properties to clone off of for an object

            var new_obj = {};
            if (in_obj instanceof Array) {
                new_obj = [];
                var array_size = in_obj.length;
                for (var i = 0; i < array_size; i++) {
                    new_obj.push(in_obj[i]);
                }
                return new_obj;
            }
            if (in_obj === null || typeof (in_obj) !== 'object') {
                return in_obj;
            }
            if (!prop_keys) {
                prop_keys = Object.keys(in_obj);
            }
            Object.each(prop_keys, function (key) {
                if (key in in_obj) {
                    new_obj[key] = this.clone_object(in_obj[key], prop_keys);
                }
            }.bind(this));
            return new_obj;


        },
        /**
         * Effectively makes the passed in list_key no longer in use, effectively unregistering it and all the values associated with it.
         * @method make_list_key_inactive
         * @param {String} list_key
         */
        make_list_key_inactive: function (list_key) {
            this.inactive_keys.push(list_key);
            delete this.active_storage[list_key];
        },
        /**
         * 
         * @method get_inactive_keys
         * @returns {Array}
         */
        get_inactive_keys: function () {
            return this.inactive_keys;
        },
        /**
         * A test for whether or not a value is registered. 
         * @method is_value_present
         * @param {String} [list_key] - Determines if we search under a specific list key for this value, if null searches all the keys for the value
         * @param {String|Number} value - The value we are search for
         * @returns {Object} An object that has the keys that containe that value and if it was found, 
         */
        is_value_present: function (list_key, value) {
            if (this.is_list_key_in_use(list_key)) {
                var elements = this.get_list_key_elements(list_key);
                if (elements.indexOf(value) > -1) {
                    return {keys: [list_key], found: true};
                }
            }
            if (list_key === null) {
                var found = [];
                Object.each(this.active_storage, function (elements, key) {
                    Object.each(elements, function (element) {
                        if (element && typeof element != 'string' && typeof element != 'number' && (element.length || Object.keys(element).length)) {
                            if (value in element) {
                                found.push(key);
                            }
                        }
                        if (element && (typeof element == 'string' || typeof element == 'number')) {
                            if (value === element) {
                                found.push(key);
                            }
                        }
                    }.bind(this));

                });
                return {keys: found, found: found.length};
            }
            return {keys: [], found: false};
        },
        /**
         * 
         * @method set_debug
         * @param {Boolean} cond
         */
        set_debug: function (cond) {
            this.options.debug = cond;
        }
    });

